import React from "react";
import PropTypes from "prop-types";
// // react plugin for creating charts
// import ChartistGraph from "react-chartist";
// // @material-ui/core

import withStyles from "@material-ui/core/styles/withStyles";
// // core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ImgMediaCard from "components/Card/ImgMediaCard.jsx";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
// // Data
import { sitesData } from "../ViewData/DashboardData"

/**
 * The example data is structured as follows:
 *
 * import image from 'path/to/image.jpg';
 * [etc...]
 *
 * const tileData = [
 *   {
 *     img: image,
 *     title: 'Image',
 *     author: 'author',
 *   },
 *   {  
 *     [etc...]
 *   },
 * ];
 */

const images = require.context("../../assets/img/sites", true);


class Dashboard extends React.Component {
 
  render() {
    //let img_src = images(`./aibolit.png`);
    let gridData = [];
    for (let i in sitesData) {
      gridData.push(
        <GridItem key={sitesData[i].name} xs={12} sm={6} md={4} lg={3}>
          <ImgMediaCard
            name={sitesData[i].name}
            image={images(`./${sitesData[i].code}.png`)}
            desc={sitesData[i].desc}
            tech={sitesData[i].tech}
            demoUrl={sitesData[i].demoUrl}
            liveUrl={sitesData[i].liveUrl}
          />
        </GridItem>
      );
    }
    return (
      <div>
        <GridContainer>{gridData}</GridContainer>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx